"use strict";


export const toggleMenu = (menuBlock, button) => {
    const openedMenu = document.querySelector(".show_block");
    const body = document.body;

    if (menuBlock.classList.contains("hide_block")) {
        menuBlock.classList.remove("hide_block");
        menuBlock.classList.add("show_block");
        body.classList.add('no-scroll');

        if (openedMenu) {
            openedMenu.classList.add("hide_block");
            openedMenu.classList.remove("show_block");
        }

    } else {
        menuBlock.classList.add("hide_block");
        menuBlock.classList.remove("show_block");
        body.classList.remove('no-scroll');
    }

    if (button) {
        if (button.classList.contains("rotate")) {
            button.classList.remove("rotate");
        } else {
            button.classList.add("rotate");
        }
    }
}

export const preloadImage = (image) => {
    const link = document.createElement("link");
    link.rel = "preload";
    link.href = image;
    link.as = "image";
    document.head.appendChild(link);
}

export const lbToKg = (value, show, decimals) => {
    return localStorage.getItem("user_language") === 'en'
        ? value + (show ? " lb" : "")
        : decimals
            ? Math.round(value * 0.453 * decimals * 10) / (decimals * 10) + (show ? " kg" : "")
            : Math.round(value * 0.453) + (show ? " kg" : "")
}

export const inToCm = (value, show) => {
    return localStorage.getItem("user_language") === 'en' ? value + (show ? '"' : "") : Math.round(value * 2.54) + (show ? " cm" : "")
}

export const ftToMeters = (value, show) => {
    return localStorage.getItem("user_language") === 'en' ? value + (show ? "'" : "") : Math.round(value * 0.3048) + (show ? " m" : "")
}

export const priceFtToMeters = (value) => {
    return localStorage.getItem("user_language") === 'en' ? value : Math.round(value / 0.3048 * 100) / 100
}

export const cubicFtToMeters = (value) => {
    return localStorage.getItem("user_language") === 'en' ? Math.round(value * 10) / 10 : Math.round(value * 0.28 * 10) / 10
}

export const clearAlerts = () => {
    const alertPlaceholder = document.getElementById('liveAlertPlaceholder');
    alertPlaceholder && alertPlaceholder.firstChild && alertPlaceholder.firstChild.remove()
}

const onCloseAlerts = () => {
    const closeButton = document.querySelector('.btn-close');
    closeButton && (closeButton.onclick = () => clearAlerts());
}

export const alert = (message, type) => {
    const alertPlaceholder = document.getElementById('liveAlertPlaceholder');

    const alertBlock = `<div class="alert alert-${type} alert-dismissible" role="alert">
        <div>${message}</div><button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button></div>`

    alertPlaceholder.innerHTML = alertBlock;
    onCloseAlerts();
}
